import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LinkIcon from '@material-ui/icons/Link';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import classnames from 'classnames';
import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { SHIPMENT_STATUS } from '../../../constants/constants';
import TrackingItemStyles from './__styles__/TrackingItem.styles';

const notTendered = [SHIPMENT_STATUS.READY_TO_TENDER, SHIPMENT_STATUS.SAVED];
export class TrackingItem extends PureComponent {
  static propTypes = {
    email: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onTriggerResendEmail: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    shipmentStatusId: PropTypes.string.isRequired,
    editable: PropTypes.bool.isRequired
  };
  state = {
    menuVisible: false,
    menuElement: null
  };
  toggleMenuVisibility = display => {
    this.setState({ menuVisible: display });
  };
  _handleMenuClick = event => {
    this.setState({ menuElement: event.currentTarget });
  };
  _handleMenuClose = () => {
    this.setState({ menuElement: null });
  };

  render() {
    const {
      email,
      classes,
      onDelete,
      onEditClick,
      t,
      shipmentStatusId,
      onTriggerResendEmail,
      editable
    } = this.props;
    const { menuElement, menuVisible } = this.state;
    const showResendLink = !notTendered.includes(shipmentStatusId);
    return (
      <div
        className={classes.trackingItemRow}
        onMouseEnter={() => {
          this.toggleMenuVisibility(true);
        }}
        onMouseLeave={() => {
          this.toggleMenuVisibility(false);
        }}
      >
        <LinkIcon
          classes={{
            root: classes.linkIcon
          }}
        />
        <Tooltip
          title={email.emailAddress}
          placement="top-start"
          classes={{ tooltip: classes.emailToolTip }}
        >
          <div className={classnames(classes.emailAddress, classes.subtitle3)}>
            {email.emailAddress}
            {showResendLink && (
              <div>
                <Button
                  className={classnames(
                    classes.button,
                    classes.resendTrackingLink,
                    classes.body2
                  )}
                  onClick={() => {
                    onTriggerResendEmail(email);
                  }}
                  color={'primary'}
                  variant={'text'}
                  disableRipple={true}
                  classes={{
                    label: classes.buttonLabelSecondaryAction,
                    root: classes.buttonRoot
                  }}
                >
                  {t('Resend tracking link')}
                </Button>
              </div>
            )}
          </div>
        </Tooltip>

        <div
          className={classnames(classes.menuButtonContainer, {
            [classes.hidden]: !menuVisible || !editable
          })}
        >
          <IconButton
            color="primary"
            disableRipple={true}
            onClick={this._handleMenuClick}
            classes={{
              root: classnames(
                classes.noPadding,
                classes.menuButton,
                classes.statusMenu
              )
            }}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <Menu
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this._handleMenuClose}
        >
          <MenuItem
            onClick={() => {
              onEditClick(email);
              this._handleMenuClose();
            }}
          >
            {t('Edit')}
          </MenuItem>
          <MenuItem
            onClick={() => {
              onDelete(email);
              this._handleMenuClose();
            }}
          >
            {t('Delete')}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}
const translatedTrackingItem = withNamespaces()(TrackingItem);

export default withStyles(
  combineStyles(TrackingItemStyles, LayoutStyles, TypographyStyles)
)(translatedTrackingItem);
